// import "../assets/css/auth.css"
import { useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import viewIcon from "../../assets/images/view-icon.svg";
// import closeEyeIcon from "../../assets/images/close-eye-icon.svg";
import { hideLoader, showLoader } from '../components/loader';
import wrong from "../assets/img/wrong-mark.svg";
import right from "../assets/img/green-tick.svg";

import {
    isContainNumber,
    isLowerCase,
    isUpperCase,
    isSpecialChar,
} from "../utils/helper";
import { Alert } from "react-bootstrap"

import validateResetPassword from '../validations/reset-password';
import { apiUrl } from '../utils/url';
import { toggleVisibility as togglePassword } from './login';
const ResetPassword = () => {
    const history = useHistory()
    const [values, setvalues] = useState({
        password_confirmation: null, password:  []
    });
    const [passwordTC, setPasswordTC] = useState(false);
    const [error, setError] = useState([])
    const [isSixChar, setSixChar] = useState(false);
    const [isOneUpperCase, setOneUpperCase] = useState(false);
    const [isOneNumber, setOneNumber] = useState(false);
    const [isTwentyChar, setTwentyChar] = useState(false);
    const [maskedPassword, setMaskedPassword] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [finalPassword, setFinalPassword] = useState();
    const passwordChar = '•';

    const formSubmit = (e) => {
        e.preventDefault();
        showLoader()
        const params = new URLSearchParams(window.location.search);
        setError(null)
        if (params.get("t")) {
            const formdata = new FormData()
            for (const key in values) {
                if (Object.hasOwnProperty.call(values, key)) {
                    formdata.append(key, values[key]);
                }
            }
            fetch(`${apiUrl}/reset-password/${params.get("t")}`, {
                body: formdata,
                method: "POST"
            }).then(async (res) => {
                hideLoader()
                const response = await res?.json();
                if (response?.status_code == 200) {
                    localStorage.setItem("token", params.get("t"));
                    toast.success("Your password was reset successfully.")
                    if (localStorage?.user) {
                        localStorage?.clear();
                    }
                    setTimeout(() => {
                        history.push("/login")
                    }, 3000);
                }
                else {
                    const errorList = [];
                    if (response?.errors?.password) 
                        response?.errors?.password?.map((val) => errorList.push(val))
                    
                    if (response?.errors?.password_confirmation)
                        response?.errors?.password_confirmation?.map((val) => errorList.push(val))

                    setError(errorList)

                    if (response?.status_message) toast.error(response?.status_message);

                }
            }).catch((err) => {
                hideLoader()
                
// console.log(err?.response?.data?.message)
            })
        }
        else{
            hideLoader()
            toast.error("Invalid token")
        }
    };
    const handleInputChange = (e) => {
        const tempPassword = e.target.value;
        const updatedPassword = [...values?.password];
    
        for (let i = 0; i < tempPassword.length; i++) {
          if (tempPassword[i] !== passwordChar) {
            updatedPassword[i] = tempPassword[i];
          }
        }
        const password = updatedPassword.join('');
        setvalues({...values,password:password});
        const masked = tempPassword.replace(/./g, passwordChar);
        setMaskedPassword(masked);
        if (passwordVisible) {
            setFinalPassword(password)
        }else {
            setFinalPassword(masked)
        }
    };
    const handleKeyUp = (e) => {
        const key = e.keyCode || e.charCode;
        const passwordLength = maskedPassword.length;
        const updatedPassword = [...values?.password];
    
        // Backspace or Delete handling
        if (passwordLength < values?.password.length) {
          const difference = values?.password.length - passwordLength;
          if (key === 8 || key === 46) {
            updatedPassword.splice(e.target.selectionStart, difference);
          }
        }
        const password = updatedPassword.join('');
        setvalues({...values,password:password});
        if (passwordVisible) {
            setFinalPassword(password)
        }
      };
    const handleChange = (e) => {
        if (e.target.name === "password") {
            if ((e.target.value.length >= 8)
                && (isContainNumber(e.target.value))
                && (isUpperCase(e.target.value))
            ) {
                setPasswordTC(false)
            }
            else {
                setPasswordTC(true)
                if (e.target.value.length >= 8) {
                    setSixChar(true);
                } else if (e.target.value.length < 8) {
                    setSixChar(false);
                }
                if (e.target.value.length >= 20) {
                    setTwentyChar(true);
                } else if (e.target.value.length < 20) {
                    setTwentyChar(false);
                }
                if (isContainNumber(e.target.value)) {
                    setOneNumber(true);
                } else if (!isContainNumber(e.target.value)) {
                    setOneNumber(false);
                }
                if (isUpperCase(e.target.value)) {
                    setOneUpperCase(true);
                } else if (!isUpperCase(e.target.value)) {
                    setOneUpperCase(false);
                }
            }
        }
        setvalues({ ...values, [e.target.name]: e.target.value })

    };
    const toggleVisibility = () => {
        if(!passwordVisible){
            setFinalPassword(values?.password);
        }else {
            setFinalPassword(maskedPassword);
        }
        setPasswordVisible(!passwordVisible);
    };
    return (
        <div id="wrapper">
            {/* <div class="page-aside-bg"></div> */}

            <div class="auth-main newmain">
                <div></div>
                <div class="steps-card">
                    <div class="card border-0 p-0 m-0 w-100 h-100">
                        <div>
                            <h1 class="newpageheading">Reset your password</h1>

                            <form action="" method="post" class="mt-4" role="form" onSubmit={formSubmit}>
                                    {error?.length > 0 && (
                                        <Alert variant="danger">
                                            {error?.map((val, index) => <li>{val}</li>)}
                                        </Alert>
                                    )}
                                <div class="form-group">
                                    <label class="fs-12 font-weight-400">
                                        <strong className='fs-12 font-weight-400'>New password</strong>
                                    </label>

                                    <div class='newinput-u'>
                                        <input type="text"
                                            placeholder="Enter your new password" name="password" value={finalPassword}
                                            onChange={handleInputChange}
                                            autocomplete="new-password"
                                            onKeyUp={handleKeyUp}
                                            required
                                            onFocus={(e) => {
                                                setPasswordTC(true)
                                                handleChange(e)
                                            }}

                                            onBlur={() => setPasswordTC(false)}
                                            />
                                            <button type="button" className="password-toggle-icon "  onClick={toggleVisibility}>
                                                {!passwordVisible ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                    <path d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                :
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                    <path d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                }
                                            </button>

                                        {passwordTC && (
                                            <div className="reset-password-tc-box w-100 position-absolute f-ph f-reg rounded shadow-2">
                                                <div className="ptc-title f-l mb-2 f-bol">
                                                    Your password must have:
                                                </div>
                                                <div className="ptc-subtitle">
                                                    {isSixChar ? (
                                                        <img
                                                            src={right}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={wrong}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    )}
                                                    At least 6 characters
                                                </div>
                                                <div className="ptc-subtitle">
                                                    {isTwentyChar ? (
                                                        <img
                                                            src={right}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={wrong}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    )}
                                                    Max 20 Characters
                                                </div>
                                                <div className="ptc-subtitle">
                                                    {isOneUpperCase ? (
                                                        <img
                                                            src={right}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={wrong}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    )}
                                                    At least 1 upper case letter (A .. Z)
                                                </div>
                                                <div className="ptc-subtitle">
                                                    {isOneNumber ? (
                                                        <img
                                                            src={right}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    ) : (
                                                        <img
                                                            src={wrong}
                                                            alt="wrong"
                                                            className="ptc-img img-fluid"
                                                        />
                                                    )}
                                                    At least 1 number (0 .. 9)
                                                </div>
                                                <div className="ptc-subtitle mt-2">
                                                    Avoid using a password that you use with other websites, that
                                                    might be easy for someone else to guess.
                                                </div>
                                            </div>
                                        )}

                                    </div>

                                </div>

                                <div class="form-group">
                                    <label className='col-12 p-0 mt-3 mb-1'>
                                        <strong className='fs-12 font-weight-400'>Confirm password</strong>
                                    </label>
                                    <div class='newinput-u'>
                                        <input type="password"
                                            required
                                            placeholder="Confirm your new password" id="toggeleShowPassword" name="password_confirmation" value={values.password_confirmation}
                                            onChange={handleChange}
                                            autocomplete="new-password"
                                             />
                                              <button type="button" className="password-toggle-icon eye-on"  onClick={togglePassword}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                    <path d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </button>
                                            <button type="button" className="password-toggle-icon eye-off" onClick={togglePassword}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            </button>
                                    </div>
                                </div>

                                <div class="form-group mt-4">
                                    <button type="submit" name="submit" class="fs-12  w-100 shadow-none  project-blue-btn align-items-center">
                                        Reset {` `}
                                            <svg width="18" height="12" class="ml-1 align-baseline" viewBox="0 0 24 18"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M14.2517 2.42589C13.711 1.87093 13.711 0.971172 14.2517 0.416217C14.7924 -0.138739 15.6691 -0.138739 16.2098 0.416217L23.5945 7.99516C24.1352 8.55012 24.1352 9.44988 23.5945 10.0048L16.2098 17.5838C15.6691 18.1387 14.7924 18.1387 14.2517 17.5838C13.711 17.0288 13.711 16.1291 14.2517 15.5741L19.2726 10.4211H1.38462C0.619914 10.4211 0 9.78483 0 9C0 8.21517 0.619914 7.57895 1.38462 7.57895H19.2726L14.2517 2.42589Z"
                                                    fill="white" />
                                            </svg>

                                    </button>
                                </div>

                                {/* <div class="row"></div> */}
                                <div class="row pt-1 mt-3 border"></div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className='zaap-logo-area'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="150" height="38" viewBox="0 0 150 38" fill="none">
                        <path d="M55.9433 25.5577C51.4081 25.5577 48.2148 22.2256 48.2148 17.0656C48.2148 12.16 51.3155 8.66602 56.3367 8.66602C60.5481 8.66602 63.4405 11.1651 64.1346 15.2607H61.2885C60.7794 12.7154 58.9052 11.1651 56.3367 11.1651C53.0972 11.1651 51.061 13.4327 51.061 17.0656C51.061 20.7447 53.1204 23.0355 56.221 23.0355C58.7432 23.0355 60.3861 21.3926 60.3861 19.0787H55.5037V16.7416H61.034C63.1165 16.7416 64.2503 17.7829 64.2503 19.7497V25.2106H61.7976V20.2588H61.7513C61.4273 23.4983 59.2985 25.5577 55.9433 25.5577Z" fill="#012125"></path><path d="M72.5593 25.5577C68.8108 25.5577 66.2423 22.8735 66.2423 19.125C66.2423 15.0756 68.9033 12.5765 72.3279 12.5765C75.7988 12.5765 78.1127 15.0062 78.1821 18.9861V19.634H68.9727C69.1578 21.786 70.4999 23.2437 72.5824 23.2437C73.9939 23.2437 75.0583 22.5496 75.4749 21.3232H78.1359C77.5111 23.9611 75.4517 25.5577 72.5593 25.5577ZM69.0884 17.7135H75.3592C75.0121 15.9549 73.9245 14.8905 72.3279 14.8905C70.7082 14.8905 69.5049 15.9549 69.0884 17.7135Z" fill="#012125"></path><path d="M83.0432 25.2106H80.3128V12.9468H82.511L82.7424 14.7516C83.506 13.479 85.0563 12.5765 86.8843 12.5765C89.499 12.5765 91.2113 14.3351 91.2113 17.0887V25.2106H88.4809V17.2275C88.4809 15.8623 87.5785 14.9599 86.0513 14.9599C84.2696 14.9599 83.0663 16.1863 83.0432 17.7829V25.2106Z" fill="#012125"></path><path d="M97.5634 25.2106H94.7867V9.0131H103.001C106.31 9.0131 108.323 11.2113 108.323 14.1037C108.323 17.3664 106.056 19.3563 103.001 19.3563H97.5634V25.2106ZM97.5634 11.5121V16.8573H102.862C104.598 16.8573 105.5 15.5615 105.5 14.1037C105.5 12.5765 104.459 11.5121 102.862 11.5121H97.5634Z" fill="#012125"></path><path d="M114.579 25.4651C111.756 25.4651 109.905 24.0999 109.928 21.8091C109.951 18.9398 112.797 18.3382 115.181 18.0605C117.032 17.8523 118.397 17.7829 118.42 16.811C118.397 15.6078 117.471 14.8211 115.898 14.8211C114.278 14.8211 113.121 15.7003 112.959 16.973H110.206C110.46 14.3814 112.774 12.5765 115.944 12.5765C119.253 12.5765 121.081 14.3814 121.081 16.9961V22.5496C121.081 22.8966 121.266 23.0818 121.683 23.0818H122.354V25.2106H121.058C119.809 25.2106 119.045 24.7015 118.837 23.7759C118.79 23.6602 118.744 23.4983 118.721 23.3594C118.004 24.6784 116.662 25.4651 114.579 25.4651ZM115.134 23.3132C117.009 23.3132 118.42 22.2487 118.42 20.6059V18.8936C117.957 19.6109 116.777 19.7728 115.482 19.9348C113.954 20.1199 112.682 20.3282 112.682 21.624C112.682 22.6884 113.538 23.3132 115.134 23.3132Z" fill="#012125"></path><path d="M129.755 30.2086C126.331 30.2086 123.971 28.5426 123.971 25.9047H126.701C126.701 27.0617 127.927 27.9873 129.755 27.9873C131.93 27.9873 133.064 26.6915 133.064 24.8403V23.1049C132.278 24.285 130.912 25.0255 129.154 25.0255C125.868 25.0255 123.508 22.4801 123.508 18.8241C123.508 15.145 125.868 12.5765 129.131 12.5765C131.051 12.5765 132.601 13.479 133.365 14.8442L133.596 12.9468H135.772V24.8403C135.772 28.0798 133.481 30.2086 129.755 30.2086ZM129.686 22.7347C131.676 22.7347 133.064 21.1149 133.064 18.801C133.064 16.4871 131.676 14.8905 129.686 14.8905C127.696 14.8905 126.331 16.4871 126.331 18.8241C126.331 21.1381 127.696 22.7347 129.686 22.7347Z" fill="#012125"></path><path d="M144.196 25.5577C140.448 25.5577 137.879 22.8735 137.879 19.125C137.879 15.0756 140.54 12.5765 143.965 12.5765C147.436 12.5765 149.75 15.0062 149.819 18.9861V19.634H140.61C140.795 21.786 142.137 23.2437 144.22 23.2437C145.631 23.2437 146.695 22.5496 147.112 21.3232H149.773C149.148 23.9611 147.089 25.5577 144.196 25.5577ZM140.726 17.7135H146.996C146.649 15.9549 145.562 14.8905 143.965 14.8905C142.345 14.8905 141.142 15.9549 140.726 17.7135Z" fill="#012125"></path><path d="M14.8362 3.60963L7.64368 6.75637C5.39969 7.73812 3.94971 9.95516 3.94971 12.4045V21.0734C3.94971 24.6444 6.89481 27.2752 10.1676 27.2449L10.4846 30.3233C5.4606 30.531 0.867188 26.5354 0.867188 21.0734V12.4045C0.867188 8.73048 3.04216 5.40492 6.40815 3.9323L13.6007 0.785557C18.249 -1.24808 23.3226 0.856484 25.4838 4.91642H21.6874C19.985 3.2084 17.3196 2.52316 14.8362 3.60963Z" fill="#012125"></path><path d="M17.4664 7.56454L11.3333 12.4656C9.41989 13.9947 8.59313 16.5115 9.22707 18.8774L11.4708 27.2509C12.0299 29.3379 13.5414 30.8133 15.3466 31.4592L16.192 34.8226C12.6928 34.3426 9.52095 31.8841 8.49327 28.0487L6.24959 19.6752C5.29868 16.1264 6.53882 12.3512 9.40897 10.0576L15.542 5.15647C20.5091 1.18715 27.8032 3.32236 29.9678 9.11263L26.5493 9.11263C24.6778 6.09658 20.4446 5.18453 17.4664 7.56454Z" fill="#012125"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M34.7751 16.4502C34.7751 12.0042 30.2121 9.02 26.139 10.802L18.9464 13.9488C16.7024 14.9305 15.2524 17.1475 15.2524 19.5969V28.2658C15.2524 32.6991 19.7915 35.6832 23.8615 33.9257L31.0541 30.8198C33.3125 29.8446 34.7751 27.62 34.7751 25.16V16.4502ZM24.9034 7.97794C31.0132 5.30492 37.8576 9.78127 37.8576 16.4502V25.16C37.8576 28.85 35.6638 32.1869 32.2761 33.6498L25.0835 36.7557C18.9786 39.3919 12.1699 34.9157 12.1699 28.2658V19.5969C12.1699 15.9229 14.3449 12.5973 17.7109 11.1247L24.9034 7.97794Z" fill="#012125"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}
export default ResetPassword